import { FiBook, FiVideo, FiMusic, FiShoppingCart } from "react-icons/fi";
import { FaPodcast } from "react-icons/fa";
import PurchaseCourses from "./PurchaseCourses";
import usePaidCourses from "../../hooks/usePaidCourses";

const StudentDashboard = () => {
  const { courses } = usePaidCourses();

  const statsData = [
    {
      id: 1,
      title: "Total Courses",
      value: courses?.filter(c => c.learning_type === "course").length,
      icon: <FiBook />,
      color: "text-blue-700",
    },
    {
      id: 2,
      title: "Total Videos",
      value: courses?.filter(c => c.learning_type === "video").length,
      icon: <FiVideo />,
      color: "text-emerald-500",
    },
    {
      id: 3,
      title: "Total Audios",
      value: courses?.filter(c => c.learning_type === "audio").length,
      icon: <FiMusic />,
      color: "text-amber-500",
    },
    {
      id: 4,
      title: "Total Podcasts",
      value: courses?.filter(c => c.learning_type === "podcast").length,
      icon: <FaPodcast />,
      color: "text-pink-500",
    },
    {
      id: 5,
      title: "Total Purchases",
      value: courses?.length,
      icon: <FiShoppingCart />,
      color: "text-violet-500",
    },
  ];

  return (
  <div className="p-6">
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
    {statsData.map((stat) => (
      <div
        key={stat.id}
        className="flex items-center min-h-[100px] p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-all"
      >
        {/* Icon (same bg for all) */}
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
          <div className={`text-[#0f6abf] text-xl`}>
            {stat.icon}
          </div>
        </div>

        {/* Text */}
        <div className="ml-4">
          <h1 className="text-sm font-medium text-gray-600">
            {stat.title}
          </h1>
          <p className="text-xl font-semibold text-gray-900">
            {stat.value}
          </p>
        </div>
      </div>
    ))}
  </div>

  <div className="mt-6">
    <PurchaseCourses />
  </div>
</div>




  );
};

export default StudentDashboard;